import React from "react"
import { isMobile } from "@digits-shared/helpers/devicesHelper"
import { useIsMobileLocation } from "src/frontend/components/Shared/Responsive/mobileRoutes"

export const Mobile: React.FC<React.PropsWithChildren> = ({ children }) => {
  const isMobileLocation = useIsMobileLocation()
  if (!isMobile || !isMobileLocation) {
    return null
  }

  return <>{children}</>
}
